import { SheetClose, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import {
  CreateTermineFormContent,
  CreateTermineSubmitButton,
} from '@/domain/termine/features/CreateTermin/shared';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function CreateTermineSheet() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full">
      <SheetHeader className="bg-neutrals-N200 flex flex-row items-baseline p-4 gap-2">
        <SheetClose>
          <FontAwesomeIcon
            className="text-primary-blue-B500"
            icon={faArrowLeft}
            fixedWidth
          />
        </SheetClose>
        <SheetTitle className="text-sm text-neutrals-N800">
          {t('domain.termine.sheet.neuerTermin')}
        </SheetTitle>
      </SheetHeader>

      <div className="flex-1 overflow-y-auto">
        <CreateTermineFormContent />
      </div>

      <hr className="h-px bg-neutrals-N300 border-0" />
      <div className="flex justify-end gap-2 py-4 px-6">
        <CreateTermineSubmitButton variant="sheet" />
      </div>
    </div>
  );
}
